import { LoginResponse, UpdatePasswordRequest } from '../../login/model';

import { DataResponse } from '../../../business/models/data.response.model';
import api from './api';

const accountsUrl = '/accounts';

export function oktaTokenRequest(code: string, codeVerifier: string, nonce: string) {
  return api.post(`${accountsUrl}/token`, { code, codeVerifier, nonce }, {
    // @ts-ignore
    _skipAuthRefresh: true
  }).catch(err => {
    console.error(err);
    throw err;
  });
}

export function oktaRefreshTokenRequest(refreshToken: string) {
  return api.post(`${accountsUrl}/refreshOktaToken`, { refreshToken }, {
    // @ts-ignore
    _skipAuthRefresh: true
  }).catch(err => {
    console.error(err);
    throw err;
  });
}

export function getMfaQRCode(username: string) {
  return api.post(`${accountsUrl}/getMfaQRCode`, { username: username })
  .catch(err => {
    console.error(err);
    return err;
  });
}

export function verifyMfaCode(username: string, mfaCode: string) {
  return api.post(`${accountsUrl}/verifyMfaCode`, { username: username, mfaCode: mfaCode})
  .catch(err => {
    console.error(err);
    return err;
  });
}

export function tryLogin(username: string, password: string) {
  return api.post(`${accountsUrl}/login`, { username: username, password: password})
  .catch(err => {
    console.error(err);
    return err;
  });
}

export function tryLoginOKTA(access_token: string) {
  return api.post(`${accountsUrl}/loginOKTA`, { access_token: access_token })
  .catch(err => {
    console.error(err);
    return err;
  });
}


export function updatePasswordApi(data: UpdatePasswordRequest) {
  return api.post(`${accountsUrl}/update-password`, data)
  .catch(err => {
    console.error(err);
    return err;
  });
}

export function logout() {
  return api.post(`${accountsUrl}/logout`, {})
  .catch(err => {
    console.error(err);
    return err;
  });
}

export function testApi() {
  return api.get<DataResponse<LoginResponse>>('/users/1');
}

